import { useMutation } from "@tanstack/react-query";
import { CustomerAccount } from "models/accountSummary";
import { useAuthenticatedRequestCreator } from "./useRequests";

export interface BatchUpdate {
    batchId: string;
    newAccount: CustomerAccount;
    newPackageId: string;
}

const useBatchUpdate = () => {
    const update = useAuthenticatedRequestCreator<boolean, BatchUpdate>(model => ({
        method: "post",
        url: "/packages/update-batch",
        data: {
            batchId: model.batchId,
            newAccountId: model.newAccount.id,
            newPackageId: model.newPackageId
        }
    }));

    const { mutateAsync: updateBatch } = useMutation(
        (model: BatchUpdate) => update(model)
    );

    return { updateBatch };
};

export default useBatchUpdate;